import axios from './index'


const origin = '/co/driver/';

const listDrivers = () => {
    return new Promise(resolve => {
        axios.get(origin + 'ListDrivers').then(res => resolve(res))
    })
}
const listDriversByTime = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/ListDriversByTime', param).then(res => resolve(res));
    })
}

const listAllDrivers = () => {
    return new Promise(resolve => {
        axios.get(origin + 'ListAllDrivers').then(res => resolve(res))
    })
}

const login = (param) => {
    return new Promise((resolve, reject) => {
        axios.post(origin + '/login', param).then(res => resolve(res)).catch(err => reject(err));
    });
}
const updateDriver = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/updateDriver', param).then(res => resolve(res));
    })
}
const loadDriverList = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/loadDriverList', param).then(res => resolve(res));
    });
}
const lookDriver = (id) => {
    return new Promise((resolve) => {
        axios.post(origin + '/lookDriver', id).then(res => resolve(res));
    });
}
const addDriver = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/addDriver', param).then(res => resolve(res));
    }

    )
}

//
const deleteDriver = param => {
    return new Promise((resolve) => {
        axios.post(origin + '/deleteDriver', param).then(res => resolve(res));
    }

    )
}
const disableDriver = param => {
    return new Promise((resolve) => {
        axios.post(origin + '/disableDriver', param).then(res => resolve(res));
    }

    )
}
const enableDriver = param => {
    return new Promise((resolve) => {
        axios.post(origin + '/enableDriver', param).then(res => resolve(res));
    }

    )
}
export default {
    listDrivers,
    listAllDrivers,
    login,
    loadDriverList,
    lookDriver,
    addDriver,
    deleteDriver,
    updateDriver,
    disableDriver,
    enableDriver,
    listDriversByTime,

}